import React, { useEffect, useState } from "react";

import { Button, Modal, Tabs, Tab } from "react-bootstrap";
import { getAllGateways, setSelectedGateway } from "../../redux/user/actions";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

import DepositImg from "../../assets/images/icons/dc.png";
import bankImg from "../../assets/images/icons/bank.png";
import RightArrow from "../../assets/images/icons/right-chevron.png";
import { getActiveBankDetails } from "../../redux/app/actions";
import DepositGatewayModal from "./DepositGatewayModal";

const DepositModal = ({ depositShow, setDepositShow }) => {
  const dispatch = useDispatch();
  const [changeContent, setChangeContent] = useState(false);
  const [gatewaysList, setGatewaysList] = useState([]);
  const { bankDetails } = useSelector((state) => state.app);
  const { user } = useSelector((state) => state.auth);
  const isDemoUser = user?.userName === process.env.REACT_APP_DEMO_USER_ID;
  const isAutoGatewayExist = gatewaysList?.deposits?.some(
    (f) => f?.type === "auto"
  );
  const [show, setShow] = useState(false);
  const [gateway, setGateway] = useState(" ");

  useEffect(() => {
    if (depositShow === true) {
      setShow(true);
    }
    if (depositShow === false) {
      setShow(false);
    }
  }, [depositShow]);

  const handleClose = () => {
    setShow(false);
    setDepositShow(false);
  };
  const handleShow = () => setShow(true);

  useEffect(() => {
    loadGtwsFromServer();
    dispatch(getActiveBankDetails());
  }, []);

  const handleGatewayClick = (item) => {
    dispatch(setSelectedGateway(item));
    setChangeContent(true);
  };

  const handleBankTransferClick = () => {
    setGateway("bank_transfer");
    setChangeContent(true);
  };

  const loadGtwsFromServer = async () => {
    const response = await getAllGateways();
    if (response && response?.data?.data?.data) {
      setGatewaysList(response?.data?.data?.data);
    }
  };

  return (
    <>
      <div className="dpst-btn">
        <Button variant="" onClick={handleShow}>
          Deposit
        </Button>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="deposit-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Deposit</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            {isDemoUser && <Navigate to="/" />}
            {!changeContent ? (
              <main className="main">
                <div className="container">
                  <div className="gatewaySection mt-4">
                    <div className="gatewaypart">
                      <Tabs
                        defaultActiveKey={"crypto"}
                        id="uncontrolled-tab-example"
                      >
                        <Tab eventKey="crypto" title="Crypto">
                          {gatewaysList?.deposits
                            ?.sort((a, b) => a?.order - b?.order)
                            ?.filter((f) => f?.type === "auto")
                            .map((item, index) => {
                              return (
                                <div
                                  className="cards1"
                                  onClick={() => {
                                    handleGatewayClick(item);
                                  }}
                                  key={index}
                                >
                                  <div className="card-icon">
                                    <img src={item?.logo || DepositImg} />
                                  </div>
                                  <p style={{ color: "#fff" }}>{item?.name}</p>
                                  <img
                                    src={RightArrow}
                                    alt="arrow"
                                    className="arrow"
                                  />
                                </div>
                              );
                            })}
                        </Tab>
                      </Tabs>
                    </div>
                  </div>
                </div>
              </main>
            ) : (
              <DepositGatewayModal
                setChangeContent={setChangeContent}
                gateway={gateway}
                setGateway={setGateway}
              />
            )}
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DepositModal;
